module.exports = __webpack_public_path__ + "static/media/plane.144ec024.svg";